import { StyleSheet } from "react-native";

const styles = StyleSheet.create({
    content: {
        paddingHorizontal: 25,
    },
    title: {
        fontSize: 18,
        color: '#2C2C2E',
        textAlign: 'center',
        marginTop: 20
    },
    contentBtn: {
        position: 'absolute',
        bottom: 60,
        paddingHorizontal: 25,
        width: '100%'
    },
    btn: {
        padding: 10,
        borderRadius: 20
    },
    textBtn: {
        color: '#fff',
        textAlign: 'center',
        fontSize: 18,
        fontWeight: '500'
    },
    contentBtnEmail: {
        position: 'absolute',
        bottom: 30,
        paddingHorizontal: 25,
        width: '100%'
    },
    textBtnEmail: {
        color: '#2C2C2E',
        textAlign: 'center',
        textDecorationLine: 'underline',
        fontWeight: 'normal'
    }
});

export default styles;
